define('models/CancellationRate',[
	'core/can',
	'models/Base',
	'moment',
	'highcharts'
], function(can, Base, moment, Highcharts) {
	
	return Base.extend({		
		findAll: 'GET /Report/CancellationRate',
		getReport: function(params, success, error) {
			var self = this;
			return can.ajax({
				type: 'GET',
				url: '/Report/CancellationRatesReport',
				data: params
			}).then(function(response) {
				return self.models(response);
			})
			.then(success, error);
		},
		chartOptions: {
            chart: {
            	zoomType: 'x'  
	        },
	        title: {
	        	text: null
	        },
	        subtitle: {
                text: null
            },
	        xAxis: {
	            type: 'datetime',
	            dateTimeLabelFormats: {
	                month: '%b %Y',
	                day: '%e %b'
	            }
	        },
	        yAxis: {
	        	min: 0,
	            title: {
	                text: 'RAP Cancellation Rate (%)',
	                style: {
	                	fontWeight: 'bold'
	                }
	            }
	        },
	        tooltip: {
	            valueSuffix: '%',
	            formatter: function() {
	            	return  '<b>Date: </b> ' + moment.utc(this.point.RapCancellationDate).format("dddd, MMM Do YYYY") + '<br />' +
	            			'<b>RAPs Cancelled: </b> ' + this.point.RapsCanceled + '<br />' +
	            			'<b>Finals Paid: </b> ' + this.point.FinalsPaid + '<br />' +
	            			'<b>RAP Cancellation Rate: </b> ' + this.point.y + '<b>%</b><br />'
	            }
	        },
	        legend: {
	        	enabled: false
	        },
	        plotOptions: {
	        	line: {
	                enableMouseTracking: true
	            },
                area: {
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [0, Highcharts.getOptions().colors[0]],
                            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                        ]
                    },
                    marker: {
                        radius: 2
                    },
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 1
                        }
                    },
                    threshold: null
                } 
            },
	        series: [{
	        	type: 'line',
	        	name: 'RAP Cancellation Rate',
	        }]
        }
	},{
		define: {
			_Rate: {
				get: function() {
					var rate = this.attr('Rate');
					return Math.round(rate ? rate * 100 : 0);
				}
			},
			_RateColor: {
				get: function() {
					var rate = this.attr('Rate');
					if(rate > 1) {
						return 'danger';
					} else if(rate > 0.25) {
						return 'warning';
					} else if(rate > 0) {
						return 'primary';
					} 
					
					return 'success';					
				}
			},
			_SuppressionChance: {
				get: function() {
					var rate = this.attr('Rate');
					if(rate > 1) {
						return 'High';
					} else if(rate > 0.25) {
						return 'Medium';
					} else if(rate > 0) {
						return 'Low';
					}

					return 'None';
				}
			},
			_EndUnixDate: {
				get: function() {
					return +moment.utc(this.attr('End')).valueOf();
				}
			},
			_isQuarterDate: {
				get: function() {
					var momentDate = moment.utc(this.attr('End'));

						if (momentDate.date() == 31 && momentDate.month() == 2) {
							return 'Quarter 1';
						} else if (momentDate.date() == 30 && momentDate.month() == 5) {
							return 'Quarter 2';
						} else if (momentDate.date() == 30 && momentDate.month() == 8) {
							return 'Quarter 3';
						} else if (momentDate.date() == 31 && momentDate.month() == 11 ) {
							return 'Quarter 4';
						} 
				}
			}
		}

	});
});
